import { useEffect } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/lib/supabase";
import { useNavigate, Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";
import FooterNavbar from "@/pages/parts/FooterNavbar";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader } from "@/components/ui/card";
import { Moon, Sun } from "lucide-react";
import { Logo } from "@/components/logo";

export default function Login() {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate('/dashboard');
      }
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        navigate('/dashboard');
      }
    });

    // Cleanup subscription
    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <Card className="w-full max-w-md gap-0">
          <CardHeader className="space-y-1">
            <div className="flex items-center space-x-2 justify-center">
              <Link to="/" className="flex items-center">
                <Logo className="h-24" />
              </Link>
            </div>
            <div className="flex items-center justify-between">
              <CardDescription>Sign in to your account to continue</CardDescription>
              <Button
                variant="ghost"
                size="icon"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
              >
                {theme === "light" ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            <Auth
              supabaseClient={supabase}
              appearance={
                {
                  theme: ThemeSupa,
                  variables: {
                    default: {
                      colors: {
                        brand: "black",
                        brandAccent: "gray",

                        brandButtonText: "white",
                      }

                    }
                  }
                }
              }
              providers={[]}
              theme={theme}
              redirectTo={window.location.origin}
            />
            <div className="flex items-center justify-center mt-4 space-x-4">

            </div>
          </CardContent>
        </Card>
      </div>
      <FooterNavbar />
    </div >
  );
}
